export const AUDIO_FILE_TYPES = 'audio/wav, audio/mp3';

export const RESPONSIVE_CLASS_NAME = ' responsive';

export const TOP_NAV_CLASS_NAME = 'top-nav';

export const ERROR_CLASS_NAME = 'error';

export const SEARCH_DEBOUNCE_VALUE = 400;

export const NAME_DEBOUNCE_VALUE = 500;

export const NAME_LEAVE_TIMEOUT = 1000;

export const EMPTY_STRING = '';

export const ZERO_VALUE = 0;

export const NOTIFICATIONS_TOASTER_DURATION = 5000;

export const TIMER_INTERVAL = 1000;

export const MAX_TIMER_DURATION = 600;

export const ALERT_INFO = 'secondary';

export const ALERT_ERROR = 'danger';

export const ALERT_SUCCESS = 'success';

export const ALERT_WARNING = 'warning';

export const AUDIO_TYPES_ACCEPTED = ['audio/mp3', 'audio/wav', 'audio/mpeg', 'audio/x-wav'];

export const MAX_FILE_SIZE_IN_BYTES = 10000000;

export const WRONG_FILE_FORMAT = 'The only accepted file formats are .mp3 and .wav.';

export const FILE_TOO_LARGE = 'Maximum file size is 10mb.';

export const MESSAGE_CREATED = 'The message was successfully created and the file is uploading.';

export const FILE_REMOVE_MESSAGE = 'Are you sure you want to remove this file?';

export const FILES_REMOVE_MESSAGE = 'Are you sure you want to remove the selected files?';

export const FILE_REMOVE_SUCCESS = 'The file was successfully removed.';

export const FILES_REMOVE_SUCCESS = 'Files were successfully removed.';

export const FILES_DOWNLOAD_SUCCESS = 'Files have been downloaded.';

export const FILE_DOWNLOAD_SUCCESS = 'File has been downloaded.';

export const URL = 'url';

export const FILE = 'file';

export const KEY_ENTER = 13;

export const CONTINUE = 'Continue';

export const CANCEL = 'Cancel';

export const FULL_DIMENSION = '100%';

export const SCROLL_EVENT = 'scroll';

export const TAP_TO_START = 'Tap to start recording';

export const IS_RECORDING = 'Recording...';

export const IS_ERROR = 'Failed to start. Check microphone permissions and refresh the page.';

export const PLAY_RECORDING = 'Tap to play recording';

export const PASSWORD_EMPTY = 'The password should not be empty';

export const USERNAME_EMPTY = 'The username should not be empty';

export const INVALID_EMAIL_ADDRESS = 'Invalid email address';

export const DELETE_RECORDING = `This action will delete your current recorded message
 and cannot be undone. Do you wish to continue?`;

export const FILES_LIST_ITEMS_PER_PAGE = 15;

export const SORT_DATE_CREATED_DESC = '-created';

export const LOCAL_STORE_AUTH_TOKEN = 'authToken';

export const LOCAL_STORE_AUTH_USER = 'authUser';

export const AUTH_USER_INCORRECT = 'Username or password is incorrect.';

export const AUTH_USER_FORBIDDEN = 'User forbidden.';

export const MAX_FILES = 'Maximum number of files reached. Please delete files to add more.';

export const RECORDING_STATUS = {
  ERROR: 'error',
  PLAYING: 'playing',
  PAUSED: 'paused',
  RECORDED: 'recorded',
  RECORDING: 'recording',
  WAITING: 'waiting',
};

export const RECORDING_SERVICE_STATUS = {
  ERROR: 'error',
  PAUSED: 'paused',
  STARTED: 'started',
  STOPPED: 'stopped',
};

// eslint-disable-next-line
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const FILE_NAME_CONFIRM = 'Fix it for me.';

export const FILE_NAME_CANCEL = 'I\'ll fix it myself.';

export const FILE_NAME_MAX_LENGHT = 50;
// eslint-disable-next-line
export const IOS_SAFARI_ONLY = 'Please use Safari to record messages on your iOS device. Audio Recording works only in Safari browser on iOS mobile.';

export const API_ERROR_MESSAGES = {
  FILE_NAME_TAKEN: 'File name already taken.'
};

export const EXTENSION_ZIP = '.zip';

export const TRANSCRIPTION_FILE_NAME = 'transcription.json';

export const DOWNLOAD_ZIP_ERROR = 'Failed to download zip messages.';



// WEBPACK FOOTER //
// ./src/constants/constants.js